export const OTP_EXPIRY_MS = 15 * 60 * 1000;

export const STEP_COPY = {
  account: {
    formTitle: 'Sign up to find experts',
    formSubtitle:
      'Get access to thousands of vetted experts across federal programs, commercial pursuits, and specialized technical domains.',
    submit: 'Sign up',
  },
  emailOtp: {
    title: 'Verify your email',
    subtitle: (email: string) => `We sent a 6-digit code to ${email}. Enter it below to continue.`,
    submit: 'Verify & continue',
    resend: 'Resend code',
    edit: 'Edit email',
  },
  inviteAccept: {
    // Rendered as "{titlePrefix} <em>{projectName}</em>" — the project name
    // gets its own italic styling in InviteAcceptStep.tsx rather than being
    // folded into a single copy string, so it reads distinctly from the
    // surrounding text.
    titlePrefix: "You're invited to",
    // Names the inviter rather than repeating the project name (already
    // shown in the title). Falls back to a generic subtitle when the
    // inviter's profile can't be resolved.
    subtitle: (inviterName: string | null) =>
      inviterName
        ? `${inviterName} invited you to collaborate on this project.`
        : "You've been invited to collaborate on this project.",
    submit: () => 'Join for free now',
    submitBusy: 'Joining…',
    goBack: 'Not my invite',
  },
  team: {
    createTitle: 'Set up your workspace',
    createSubtitle: "Tell us about your organization. You'll add billing in the next step.",
    joinTitle: (teamName: string) => `Join ${teamName}`,
    joinSubtitle:
      "Your email matches an existing team on OnFrontiers. You'll be added to the workspace as soon as your request is approved.",
    submit: 'Continue to payment',
    workspaceOwnerCallout:
      "You'll be the team owner. You can invite teammates and transfer ownership later from settings.",
  },
  subscription: {
    title: 'Activate your subscription',
    subtitle: 'Cancel any time from settings.',
    submitTrial: (trialDays: number) => `Start ${trialDays}-day free trial`,
    submitPaid: 'Activate subscription',
    secured: 'Secured by Stripe',
    cardSaved: 'Your card is saved.',
    useDifferentCard: 'Use a different card',
  },
  confirmation: {
    titlePaid: 'Subscription activated!',
    subtitlePaid: 'You now have access to the full expert network.',
    titleTrial: 'Free trial activated!',
    subtitleTrial: (trialDays: number) =>
      `Explore the full expert network for ${trialDays} day${trialDays === 1 ? '' : 's'}.`,
    ctaDashboard: 'Go to your dashboard',
    ctaContinue: 'Continue',
  },
  confirmExit: {
    title: 'Leave signup?',
    body: 'Your account is saved. You can resume from your dashboard.',
    cancel: 'Stay',
    confirm: 'Leave',
  },
} as const;
